// ── App-wide context ──
// Exposes App()'s state + handlers (go, setModal, saveRec, role, …) so nested
// pages/forms can consume them via useApp() instead of closing over App's scope.
// This is the seam that lets pages move out of App.js into apps/*/pages files.
import { createContext, useContext } from "react";

export const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);
